<carousel-slide>

  <img class="carousel-btn carousel-btn-left" src={ arrow } alt="anterior" if={ props.arrows }>
  <div class="carousel" id="carousel-{ props.carouselid }">
    <div class="carousel-container">
      <slot/>
    </div>
  </div>
  <img class="carousel-btn carousel-btn-right" src={ arrow } alt="proximo" if={ props.arrows }>
  <div class="carousel-bullets" if={ props.bullets }>
    <a each={ item in props.arr} class="carousel-bullet"></a>
  </div>

  <script>
    import EmblaCarousel from 'embla-carousel'
    import arrow from '../media/icon-arrow.svg'
    import './carousel-slide.scss'

    export default {
      components: {
      },
      arrow,
      onMounted(props, state) {
        this.isFirstSlide = true

        // embla carousel options
        const carouselOptions = { loop: true, draggableClass: 'is-grabbing' }

        // embla carousel
        this.emblaNode = this.$(`#carousel-${props.carouselid}`)
        this.embla = EmblaCarousel(this.emblaNode, carouselOptions)

        this.embla.on('select', this.handleChange)

        props.bullets && this.setBullets()
        props.arrows && this.setPrevNextButtons()
        props.autoPlay && this.setAutoPlay(props.autoPlay)

        props.scrollEffect && window.addEventListener('scroll', this.scrollEffect)
      },
      onBeforeUnmount() {
        this.stopAutoPlay()
        window.removeEventListener('scroll', this.scrollEffect)
      },
      scrollEffect() {
        // embla scroll reach
        const positionFromTop = this.emblaNode.getBoundingClientRect().top + window.scrollY
        if ((window.scrollY >= positionFromTop*.85) && this.isFirstSlide) {
          this.isFirstSlide = false
          this.embla.scrollNext()
        } else if ((window.scrollY <= positionFromTop*.85) && !this.isFirstSlide){
          this.isFirstSlide = true
          this.embla.scrollPrev()
        }
      },
      setAutoPlay(t) {
        this.timeout = setTimeout(() => {
          if (!document.hidden) {
            this.embla.scrollNext()
          }
        }, t)
      },
      stopAutoPlay() {
        clearTimeout(this.timeout)
      },
      setPrevNextButtons() {
        this.$('.carousel-btn-left').addEventListener('click', () => {
          this.embla.scrollPrev()
        })
        this.$('.carousel-btn-right').addEventListener('click', () => {
          this.embla.scrollNext()
        })
      },
      handleChange() {
        // using timeout to prevent change cur slide after user select manually
        // the handler will stop the timeout, if changed manually, and set again
        this.props.autoPlay && this.stopAutoPlay()
        this.props.autoPlay && this.setAutoPlay(this.props.autoPlay)

        this.props.onChange && this.props.onChange(this.embla.selectedScrollSnap())
      },
      setBullets() {
        const bulletsContainer = this.$('.carousel-bullets')
        const slides = this.$$('.carousel-container > *')

        slides.forEach((x, idx) => {
          const bullet = document.createElement('a')
          bullet.classList.add('carousel-bullet')
          bullet.addEventListener('click', () => {
            this.embla.scrollTo(idx)
          })

          bulletsContainer.append(bullet)
        })

        bulletsContainer.querySelector('.carousel-bullet:first-child').classList.add('activated-bullet')

        this.embla.on('scroll', () => {
          this.$$('.carousel-bullet').map((bullet, i) => {
            bullet.classList.remove('activated-bullet')
          })
          this.$$('.carousel-bullet')[this.embla.selectedScrollSnap()] && this.$$('.carousel-bullet')[this.embla.selectedScrollSnap()].classList.add('activated-bullet')
        })
      }
    }
  </script>
</carousel-slide>
